import { useContext, useEffect, useState } from 'react';
import { AppContext } from 'App';
import dynamicModificationRulesService from './dynamicModificationRulesService';

export const isDynamicModificationEnabled = (appState) =>
  !!appState?.company?.customConfig?.enableDynamicModification;

/**
 * Rules the company can pick on a question, as select options, and a lookup of
 * a rule's name. Empty and disabled when the company does not use dynamic
 * modification.
 */
export default function useDynamicModificationRules() {
  const { appState } = useContext(AppContext);
  const isEnabled = isDynamicModificationEnabled(appState);
  // Lists render many question views; once loaded, each starts with the options
  // instead of re-rendering when the shared request resolves.
  const [options, setOptions] = useState(
    () => dynamicModificationRulesService.getLoadedRuleOptions() || [],
  );

  useEffect(() => {
    if (!isEnabled || dynamicModificationRulesService.getLoadedRuleOptions()) return;
    let isMounted = true;
    dynamicModificationRulesService
      .getRuleOptions()
      .then((loaded) => isMounted && setOptions(loaded));
    return () => {
      isMounted = false;
    };
  }, [isEnabled]);

  // Forms keep the id as { value }, detail views as the plain id.
  const ruleName = (rule) => {
    const id = Number(rule?.value ?? rule);
    return (isEnabled && id && options.find((option) => option.value === id)?.label) || null;
  };

  return { isEnabled, options: isEnabled ? options : [], ruleName };
}
